import { Component, OnInit } from '@angular/core';
import { InventoryService } from '../../../services/inventory.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-getproduct-lookup',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './getproduct-lookup.component.html',
  styleUrl: './getproduct-lookup.component.scss'
})
export class GetproductLookupComponent implements OnInit {

  @Output() filteredProductsEvent: EventEmitter<{ products: any[], data: any }> = new EventEmitter<{ products: any[], data: any }>();

  products:[]=[];
materialtype:any;
  constructor(private inventoryService: InventoryService,public ref: DynamicDialogRef,
    private config: DynamicDialogConfig) {
  }

  allProducts: boolean = false;
  loader: boolean = false;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10000,
    id: 0
  }

  ngOnInit() {
    this.getProducts(this.pageRequest)
    this.materialtype = this.config.data?.Material;
    this.allProducts = this.config.data?.allProducts;
  }

  SelectOption(event: any) {
    if(event?.data){
      this.ref.close(event?.data);
    }else{
      this.ref.close(event);
    }
  }

  getProducts(data: any) {
    this.loader = true;
    this.inventoryService.getProducts(data).subscribe({
      next: (response: any) => {
        this.loader = false;
        if(this.allProducts){
          this.products = response.products;
          return;
        }

        if(this.materialtype ==='RM1113'){
          if (response && response.products) {
            this.products = response.products.filter((product: any) => product.productType === 'RM1113');
          }
        }
        else if(this.materialtype=='FG1112'){
          if (response && response.products) {
            this.products = response.products.filter((product: any) => product.productType === 'FG1112');
          }
        }
      },
      error: error => {
        this.loader = false;
        console.log(error);
      }
    });
  }

}
